<template>
  <v-card
    :id="`baseDraggableCard${uid}`"
    :style="vCardStyle">
    <v-card-title class="pa-0">
      <base-widget-header
        :id="`baseDraggableCard${uid}Header`"
        :dense="true" tooltip
        :loading="loading" style="width:100%;cursor:grab" :label="computedTitle"
        @close-parent-widget="closeCard">
        <template #anyButton>
          <slot name="anyButton" />
        </template>
      </base-widget-header>
    </v-card-title>
    <v-card-text :style="vCardTextStyle" class="px-0 ">
      <slot name="content" />
    </v-card-text>
    <v-divider v-if="$slots.actions" />
    <v-card-actions v-if="$slots.actions" class="justify-end mx-3">
      <div style="width:100%;">
        <slot name="actions" />
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  name: 'BaseDraggableCard',
  props: {
    tooltip: { type: Boolean, default () { return false } },
    loading: { type: Boolean, default () { return false } },
    title: { type: String, default () { return 'Placeholder' } },
    width: { type: Number, default () { return 500 } },
    subtitle: { type: String, default () { return '' } },
    heightModifier: { type: Number, default () { return 0 } },
  },
  data () {
    return {
      leftPosition: 0,
      topPosition: 0,
      uid: null,
    }
  },
  computed: {
    vCardStyle () {
      return {
        left: this.leftPosition + 'px',
        top: this.topPosition + 'px',
        position: 'absolute',
        zIndex: 100,
        width: `${this.width}px`,
        height: 'auto',
        maxHeight: 370 + this.heightModifier + 'px',
      }
    },
    vCardTextStyle () {
      return {
        height: 'auto',
        overflowY: 'auto',
        overflowX: 'hidden',
        maxHeight: 370 + (this.heightModifier ? this.heightModifier - 550 : 0) + 'px',
      }
    },
    computedTitle () {
      if (this.subtitle) {
        return this.title + '-' + this.subtitle
      }
      return this.title
    },
  },
  created () {
    // not really unique but it's good enough
    this.uid = Math.random()
  },
  mounted () {
    this.setDivPosition(window.innerWidth, window.innerHeight)
    this.makeDivMovable(document.getElementById(`baseDraggableCard${this.uid}`))
  },
  methods: {
    makeDivMovable (elmnt) {
      if (!elmnt) {
        return
      }
      const vm = this
      let pos1 = 0
      let pos2 = 0
      let pos3 = 0
      let pos4 = 0
      if (document.getElementById(elmnt.id + 'Header')) {
        /* if present, the header is where you move the DIV from: */
        document.getElementById(elmnt.id + 'Header').onmousedown = dragMouseDown
      } else {
        /* otherwise, move the DIV from anywhere inside the DIV: */
        elmnt.onmousedown = dragMouseDown
      }
      function dragMouseDown (e) {
        e.preventDefault()
        // get the mouse cursor position at startup:
        pos3 = e.clientX
        pos4 = e.clientY
        document.onmouseup = closeDragElement
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag
      }
      function elementDrag (e) {
        e.preventDefault()
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX
        pos2 = pos4 - e.clientY
        pos3 = e.clientX
        pos4 = e.clientY
        // set the element's new position:

        elmnt.style.top = (elmnt.offsetTop - pos2) + 'px'

        elmnt.style.left = (elmnt.offsetLeft - pos1) + 'px'
      }
      function closeDragElement () {
        /* stop moving when mouse button is released: */
        document.onmouseup = null
        document.onmousemove = null
        vm.leftPosition = elmnt.style.left.slice(0, -2)
        vm.topPosition = elmnt.style.top.slice(0, -2)
      }
    },
    setDivPosition (windowWidth, windowHeight) {
      this.leftPosition = (windowWidth - 200) / 2
      this.topPosition = (windowHeight - 700) / 2
    },
    closeCard () {
      this.$emit('close-card')
    },
  },
}
</script>

<style scoped>
.animation {
  transition: max-height 1000ms ease;
}
</style>
